/* eslint-disable react/display-name */
import React,{ forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import { saveAs } from 'file-saver';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import EnhancedTable from './components/Table';
import fetch_endpoint from './utils/Functions';
import InputBase from '@material-ui/core/InputBase';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  root: {
    padding: theme.spacing(4)
  },
  paper: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  table: {
    marginTop: theme.spacing(2)
  }

});

class Dashboard extends React.Component {
  // Gets access token using fetch_endpoint function
  get_access_token = async ()=>{
  
    let response =  await fetch_endpoint({} ,'/get_access_token')
    return response.accessToken
 
  }
  
  CustomRouterLink = forwardRef((props, ref) => (
    <div
      ref={ref}
      style={{ flexGrow: 1 }}
    >
      <RouterLink {...props} />
    </div>
  ));
  
  
  componentDidUpdate(){
    if(!this.props.user && !this.props.user.subscribed){
      this.props.history.push('/sign-in')
    }
  }

  // This function gets the value in input, returns a playlist with
  // using that value as query, keep in mind that this function
  // only makes an initial search using offset=0 , limit=40
  handle_search = (e)=>{
    e.preventDefault()
    this.setState({
      loading:true
    })
    if(this.state.search_term){
      this.get_playlists(this.state.search_term,this.state.access_token).then((resp)=>{
        if(typeof(resp.data)=='string'){
          this.setState({
            data:[]
          })
        }else{
          this.setState({
            data:resp.data,
            loading:false
          })
        }
      })
    } 
  }

  // This function uses FileSaver.js library to export current data on state
  save_json = ()=>{
    if(this.state.data)
    {
      var data = this.state.data
      if(this.state.filter_mails){
        data = data.filter((val,idx)=>{
          if(val['mail']){
            return val
          }
        })
      }
      // Create a blob of the data
      var fileToSave = new Blob([JSON.stringify(data)], {
        type: 'application/json',
        name: 'exported_playlists.json'
      });

      // Save the file
      saveAs(fileToSave, 'exported_playlists.json');
    
    }
  }

  // Updates search_term state every time a key is pressed
  update_search_term = (e)=>{
    this.setState({
      search_term: e.target.value
    })

  }

  // Gets playlists, given offset, limit and access_token
  get_playlists = async (query,access_token)=>{

    let data = {
      query:query,
      access_token:access_token
    }

    return await fetch_endpoint(data,'/get_playlists')
  }

  // An helper function to set state with given data dictionary
  // and return true when it's done
  set_state_and_wait = async (data)=>{

    this.setState(data,()=>{
      return true
    })
  }

  // Fetch access token on start
  async componentDidMount(){
    // get access token when component is mounted
    let access_token = await this.get_access_token()
    await this.set_state_and_wait({
      access_token:access_token
    })
  }

  toggle_filter_mails = (event)=>{
    this.setState({
      filter_mails: event.target.checked
    })
  }

  constructor(props){
    super(props);
    this.state= {
      access_token:null,
      data:[],
      search_term:'',
      filter_mails: false,
      open_load_more_dialog: false
    }
  }

  renderDashboard = (classes,user)=>{
    if(typeof(user)==='object')
    {
      if(user.subscribed){
        return (
          <div className={classes.root}>
            <FormGroup row>
              <Grid>
                <Paper 
                  className={classes.paper} 
                  component="form"
                  onSubmit={this.handle_search}
                >
                  <InputBase
                    className={classes.input}
                    inputProps={{ 'aria-label': 'search google maps' }}
                    onChange={this.update_search_term}
                    placeholder="Search Playlists"
                  />
                  <IconButton 
                    aria-label="search" 
                    className={classes.iconButton} 
                    onClick={this.handle_search}
                    type="submit"
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </Grid>
              <FormControlLabel
                control={<Switch
                  color="secondary"
                  checked={this.state.filter_mails}
                  onChange={this.toggle_filter_mails}
                  name="checkedA" />}
                label="Filter Emails"
                style={{marginLeft:'3rem'}}
              />
              <Button 
                color="primary"
                onClick={this.save_json}
                style={{marginLeft:'3rem'}}
                variant="contained" 
              >
                Export as JSON
              </Button>
            </FormGroup>
            <EnhancedTable 
              data={this.state.data}
              filter_mails={this.state.filter_mails}
              loading={this.state.loading}
            />
          </div>
        )
      }
      else{
        return(
          <div className={classes.root}>
            <Grid mdOffset={8}>
              <Paper style={{margin:'auto',padding:'50px'}}>
                <Typography 
                  variant="h2">
                  Please set your payment option to use this tool.
                </Typography>
                <Button
                  color="primary"
                  style={{marginTop:'30px'}}
                  variant="contained"
                  component={this.CustomRouterLink}
                  to="/account">
                  Go to Account Settings
                </Button>
              </Paper>
            </Grid>
          </div>
        )
      }
    }
    else
    {
      return(
        <div className={classes.root}>
          <div style={{position:'absolute',top:'50%',left:'55%'}}>
            <CircularProgress
              size={80}
              thickness={3.8}
            />
          </div>
        </div>
      )
    }
  }

  render(){
    const { classes, user } = this.props
    return this.renderDashboard(classes,user)
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Dashboard)
